import { render, staticRenderFns } from "./AggregateRating.vue?vue&type=template&id=68e9d738&"
import script from "./AggregateRating.vue?vue&type=script&lang=js&"
export * from "./AggregateRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports